<template lang="pug">
div
  v-subheader.px-0.text-subtitle-1 {{ inputTitle }}
  v-card.d-inline-flex.pa-2(
    v-if="imageName && imageUrl"
    elevation="0"
  )
    v-icon mdi-camera
    v-btn(
      plain
      elevation="0"
      :href="imageUrl"
    ) {{ imageName }}
    v-btn(
        color="red"
        @click="removeImage" icon
    )
      v-icon(color="error") mdi-close
  validation-provider(
    ref="provider"
    v-slot="{ errors, valid, validate }"
    :rules="rules"
    :name="name"
    :vid="vid"
  )
    v-file-input(
      ref="image"
      name="image_file_name"
      :label="label"
      :error-messages="errors"
      prepend-icon=""
      prepend-inner-icon="mdi-camera"
      filled
      rounded
      @change="selectImage"
    )
    div.pl-2(v-show="newImageUrl")
      vue-cropper.mb-4(
        ref="cropper"
        :src="newImageUrl"
        :aspect-ratio="378 / 225"
        :zoomOnWheel="false"
        preview=".preview"
      )
      p Предпросмотр
      div.mb-4(class="preview")
    div.mb-5(v-if="showOldImage && imageUrl")
      v-img.mx-auto(:src="imageUrl || ''" max-width="300px")
  v-progress-linear.mb-2.mx-2(
    v-if="progress"
    :value="progress"
    color="primary"
    height="6"
    rounded
  )

</template>

<script>
import VueCropper from 'vue-cropperjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';
import APIService from '@/services/APIService';

export default {
  name: 'ImageUpload',
  components: { VueCropper },
  props: {
    rules: {
      type: String,
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'Файл',
    },
    errors: {
      type: Array,
      default: () => ([]),
    },
    minWidth: {
      type: Number,
      default: 0,
    },
    minHeight: {
      type: Number,
      default: 0,
    },
    minSizeOfOneSide: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: 'Изображение',
    },
    existingImageName: {
      type: String,
      default: '',
    },
    existingImageUrl: {
      type: String,
      default: '',
    },
    inputTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showOldImage: true,
      imageName: this.existingImageName,
      imageUrl: this.existingImageUrl,
      newImageUrl: '',
      progress: 0,
    };
  },
  methods: {
    selectImage(file) {
      if (!file) {
        this.newImageUrl = '';
        this.$emit('image:changed', 'image');
        return;
      }
      if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name)) {
        this.$toasted.error(
          'Неверный файл. Доступные расширения для изображения: jpg, svg, jpeg, png, bmp, gif',
          {
            duration: 5000,
          },
        );
        return;
      }
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width <= this.minWidth || img.height <= this.minHeight) {
          this.$toasted.error(
            `Размер изображения должен быть не менее ${this.minWidth}x${this.minHeight} пикселей`,
            {
              duration: 3000,
            },
          );
          return;
        }
        if (this.minSizeOfOneSide) {
          if (img.width <= this.minSizeOfOneSide && img.height <= this.minSizeOfOneSide) {
            this.$toasted.error(
              `Размер изображения должен быть не менее ${this.minSizeOfOneSide} по большей стороне`,
              {
                duration: 3000,
              },
            );
            return;
          }
        }
        this.showOldImage = false;
        this.newImageUrl = URL.createObjectURL(file);
        this.$refs.cropper.replace(this.newImageUrl);
      };
      this.$emit('image:changed', 'image');
    },
    removeImage() {
      this.imageName = '';
      this.imageUrl = '';
      this.selectImage('');
    },

    /**
     * Загружает файл на сервер, возвращает имя файла
     * @returns {Promise<unknown>}
     */
    uploadFile() {
      this.progress = 0;
      if (this.showOldImage) return null;
      return new Promise((resolve) => {
        this.cropImage()
          .then(async (croppedImage) => {
            const CHUNK_SIZE = 500 * 1024;
            const fileSize = croppedImage.size;
            const dispositionName = Math.random().toString(32);
            const chunksCount = Math.ceil(fileSize / CHUNK_SIZE);

            let response;
            for (let start = 0; start < fileSize; start += CHUNK_SIZE) {
              const data = new FormData();
              data.append('file', croppedImage.slice(start, start + CHUNK_SIZE), dispositionName);
              // eslint-disable-next-line no-await-in-loop
              response = await APIService.post('/uploads', data, {
                headers: {
                  'Content-Type': 'application/octet-stream',
                  Accept: 'application/json',
                  'Content-Disposition': `attachment; filename=${dispositionName}`,
                  'Content-Range': `bytes ${start}-${start + CHUNK_SIZE}/${fileSize}`,
                },
              });
              this.progress += Math.ceil(100 / chunksCount);
            }
            resolve(response.data.data.file_name);
          //   const formData = new FormData();
          //   formData.append('file', croppedImage);
          //   this.$rHandler(
          //     this.$api.system.uploadFiles(formData),
          //     (r) => resolve(r.data.data.file_name),
          //     (e) => {
          //       console.log('Ошибка в ImageUploader', e);
          //       this.$toasted.error('Не удалось загрузить файл', {
          //         duration: 2000,
          //       });
          //       this.$refs.provider.setErrors(e.response.data.validation.file);
          //       reject(e.response.data);
          //     },
          //   );
          })
          .catch((e) => {
            console.log('Ошибка в кропе', e);
          });
      });
    },

    /**
     * Обрезает изображение курса, возвращает сам Blob
     * @returns {Promise<unknown>}
     */
    cropImage() {
      return new Promise((resolve) => {
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          resolve(blob);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .preview {
    width: 100%;
    height: calc(378px * (225 / 378));
    overflow: hidden;
    border: 1px solid #aaa;
  }

</style>
